import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "components/Button/IconButton";
import { getVastuDengiList } from "services/vastudengi";
import { dateFormat } from "utils";

export default function VastuDengiList() {
  const navigate = useNavigate();
  const [record, setRecord] = useState([{}]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getVastuDengiList({
        page: activePage,
        search: search,
        limit: limit,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.VastuDengi;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit) + 1);
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap w60per">
                <div className="SearchBox w-100 " style={{ gap: "2px" }}>
                  <div
                    className="div_wrap mx-1 "
                    style={{ width: "35%" }}
                  ></div>
                  <div className="div_wrap mx-1 w40per">
                    <input
                      type="text"
                      placeholder="शोधा"
                      name="search"
                      className="form-control"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button to={"add-dengi"}>नवीन देणगी जोडा</Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">वस्तू देणगी</h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>अनु.क्र./Sr.No.</th>
                    <th>देणगी देणाऱ्याचे नाव</th>
                    <th>देणगी घेणाऱ्याचे नाव</th>
                    <th>शहर</th>
                    <th>मोबाईल</th>
                    <th>देणगीवस्तूचे नाव</th>
                    <th>प्रमाण</th>
                    <th>दिनांक</th>
                    <th>क्रिया/Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          ProviderName,
                          ProviderMobile,
                          ItemName,
                          Quantity,
                          DateofGiving,
                          ReceiverName,
                          City,
                          AddedOn,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 10}</td>
                          <td>{ProviderName}</td>
                          <td>{ReceiverName}</td>
                          <td>{City}</td>
                          <td>{ProviderMobile}</td>
                          <td>{ItemName}</td>
                          <td>{Quantity}</td>
                          <td>{dateFormat(DateofGiving)}</td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    navigate(`update-dengi/${id}`);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 && (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={10}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
